export const MAX_GRID_ITEM_HEIGHT = "500px";
export const MAX_DOCUMENT_PREVIEW_HEIGHT = "500px";